import { makeStyles } from '@material-ui/core'

export const useStyle = makeStyles((theme) => {
  return {
    cards: {
      padding: '8px 16px 8px 16px',
      backgroundColor: theme.palette.primary.light,
      boxShadow: '0px 1px 3px rgba(0, 0, 0, 0.12), 0px 0px 0px 1px rgba(19, 45, 74, 0.04)',
      borderRadius: 4,
      display: 'flex',
      justifyContent: 'flex-start',
      position: 'relative',
      alignItems: 'center',
      gap: 16,
      '& $icon': {
        color: theme.palette.primary.main,
      },
    },
    content: {
      color: theme.palette.common.black,
      wordBreak: 'break-word',
    },
    icon: {
      display: 'flex',
    },
    error: {
      backgroundColor: theme.palette.error.light,
      borderTopLeftRadius: 8,
      borderBottomLeftRadius: 8,
      borderLeft: `8px solid ${theme.palette.error.main}`,
      '& $icon': {
        color: theme.palette.error.main,
      },
    },
    warning: {
      backgroundColor: theme.palette.warning.light,
      borderTopLeftRadius: 8,
      borderBottomLeftRadius: 8,
      borderLeft: `8px solid ${theme.palette.warning.main}`,
      '& $icon': {
        color: theme.palette.warning.main,
      },
    },
    success: {
      backgroundColor: theme.palette.success.light,
      borderTopLeftRadius: 8,
      borderBottomLeftRadius: 8,
      borderLeft: `8px solid ${theme.palette.success.main}`,
      '& $icon': {
        color: theme.palette.success.main,
      },
    },
    info: {
      backgroundColor: theme.palette.primary.light,
      borderTopLeftRadius: 8,
      borderBottomLeftRadius: 8,
      borderLeft: `8px solid ${theme.palette.primary.main}`,
      '& $icon': {
        color: theme.palette.primary.main,
      },
    },
    dividerVertical: {
      position: 'absolute',
      border: `4px solid ${theme.palette.primary.main}`,
      top: 0,
      left: 0,
      height: '100%',
      background: theme.palette.primary.main,
      borderTopLeftRadius: 8,
      borderBottomLeftRadius: 8,
    },
  }
})
